const BUILTIN_ACTION_TYPES = new Set([
  'createfile',
  'addcsvcolumn',
  'addexcelcolumn',
  'addexcelrow',
  'createjsonfile',
  'createzipfile',
  'createxmlfile',
  'copyfile',
  'createfolder',
  'createproject',
  'cropimage',
  'saveimagetofile',
  'createdocx',
  'createdocxtemplate',
  'createdocxtemplatev2',
  'replacewordtext',
  'anonymizepii',
  'createexcelfromtemplate',
  'addpasswordexcel',
  'addpassworddocx',
  'convertdocxtopdf',
  'convertpdftodocx',
  'documentlegalpdftodocx',
  'pdftotoword',
  'convertpdftohtml',
  'convertpdfimagetopdftext',
  'rotatepdfimageocrpdf',
  'createpdf',
  'insertimagetopdf',
  'searchandinsertimagetopdf',
  'searchandinsertrichtexttopdf',
  'createtagbrowseweb',
  'browseweb',
  'computeruse',
  'cmqverifydoctor',
  'oiiqverifynurse',
  'generativeanswer',
  'generativeanswerfile',
  'deterministicanswer',
  'formextraction',
  'extractimagetotag',
  'simplejavascript',
  'manualtag',
  'triggerflow',
  'looptriggerflow',
  'generatewidget',
  'dashboardsnapshot',
  'validatereservation',
  'validatedoctorlicense',
  'sendapi',
  'callmcp',
  'msteamsSendMessage',
  'sendemail',
  'sendOutlookEmail',
  'moveOutlookEmail',
  'sendGmailEmail',
  'sendLinkedinPost',
  'sendLinkedinCompanyPost',
  'weatherapi',
].map((type) => type.toLowerCase()));

const PUBLIC_ICON_ROOT = `${process.env.PUBLIC_URL || ''}/images/actions`;

export const isBuiltinActionType = (type) => (
  BUILTIN_ACTION_TYPES.has(String(type || '').trim().toLowerCase())
);

export const getActionIcon = (type) => {
  const normalizedType = String(type || '').trim().toLowerCase();
  const iconName = isBuiltinActionType(normalizedType) ? normalizedType : 'generic';
  return `${PUBLIC_ICON_ROOT}/${iconName}.png`;
};

export const ACTION_ICON_FALLBACK = `${PUBLIC_ICON_ROOT}/generic.png`;

